import styled from "styled-components";
import { Card } from "antd";

export const SourceCard = styled(Card)`
  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    margin-bottom: 1rem;
  }
  &.selected {
    background-color: #000;
    color: #fff;
  }
`;

export const BrandCard = styled(Card)`
  &.selected {
    background-color: #000;
    color: #fff;
  }
  .ant-card-head,
  .ant-card-body {
    color: inherit;
  }
`;

export const MapControlsCard = styled(Card)`
  margin-right: 16px;
  margin-bottom: 16px;
`;
